export const ANALYTICS_CONTEXT = "Data Browse";
export const RELOAD_INTERVAL = 2000;
